import { Component, OnInit } from '@angular/core';
import { UserService } from '../services/user.service';
import { Router } from '@angular/router';
import { SurveyDetails } from '../models/dto/survey';
import { CriteriaDetails } from '../models/dto/criteria';
import { VisionModel } from '../models/vision.model';

@Component({
  selector: 'app-jobs-empty',
  templateUrl: './jobs-empty.component.html',
  styleUrls: ['./jobs-empty.component.scss']
})

export class JobsEmptyComponent implements OnInit {
  current_survey: any;
  survey_data: SurveyDetails;
  vision_title: string;

  constructor(private visionModel: VisionModel) {
    this.current_survey = localStorage.getItem('current_survey');
  }

  ngOnInit() {
    if (this.current_survey && this.current_survey !== 'null') {
      this.current_survey = JSON.parse(this.current_survey);
      this.vision_title = this.current_survey.title;
    } else {
      const visionTypeId = this.visionModel.getCurrentSurveyTypeId();
      this.visionModel.setSurveyInStorageFromType(visionTypeId).subscribe(result => {
        this.current_survey = JSON.parse(localStorage.getItem('current_survey'));
        this.vision_title = this.current_survey.title;
      });
    }
  }

}



// WEBPACK FOOTER //
// /var/www/angular/mobilit-web/src/app/jobs/jobs-empty.component.ts